import { render, staticRenderFns } from "./FreelancerList.vue?vue&type=template&id=700113f6&"
import script from "./FreelancerList.vue?vue&type=script&lang=js&"
export * from "./FreelancerList.vue?vue&type=script&lang=js&"
import style0 from "./FreelancerList.vue?vue&type=style&index=0&id=700113f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports